import { Expose } from 'class-transformer';

import type ImageInterface from '../types/Image';
import type Product from '../classes/Product';
import type MetaDataInterface from '@/types/MetaData';

export default class MenuCategory {
  @Expose() id?: string = undefined;
  @Expose() name?: string = undefined;
  @Expose() images?: ImageInterface[] = [];
  @Expose() products?: Product[] = [];
  @Expose() metadata?: MetaDataInterface[];
  @Expose() description?: string = undefined;

  constructor(id: string, name: string, images: ImageInterface[], products: Product[], metadata: MetaDataInterface[], description: string) {
    this.id = id;
    this.name = name;
    this.images = images;
    this.products = products;
    this.metadata = metadata;
    this.description = description;
  }

  getImageByKey = (key: string) => {
    if (this.images) {
      const keyedImages = this.images.filter(img => {
        return img.position == key
      })
      return keyedImages.length > 0 ? keyedImages[0] : null;
    }
  }

  getMetaDataByKey = (key: string) => {
    let data = null;
    if (this.metadata) {
      data = this.metadata.find(md => {
        return md.key == key
      })
    }

    return data ? data.value : null;
  }

  isCatering = ():boolean => {
    return this.getMetaDataByKey('catering')
  }
}
